import { ApiResponse, ApiService } from 'src/services/core';
import VwKullaniciDTO from 'src/models/Base/Auth/VwKullaniciDTO';

class VwKullaniciService extends ApiService<VwKullaniciDTO> {
  constructor() {
    super('Account');
  }

  user = (): Promise<ApiResponse<VwKullaniciDTO>> => {
    return this.get<VwKullaniciDTO>('User', {});
  };
}
export default new VwKullaniciService();
